import {RootState} from 'store';

export const getBookExperienceQuantity = (offerId?: string) => (state: RootState) =>
  offerId && state.bookExperience.offerQuantity[offerId];
